"use client";
import React, { useState } from "react";
import Modal from "react-modal";
import "../style/index.css";
import Loading from "../components/loading";
import Button from "../components/ui/button";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { acceptRepayment } from "../network/fetchers";
import { toast } from "sonner";

const CancelLoanModal = (props) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const { mutateAsync: cancelLoan, isPending } = useMutation({
    mutationKey: ["cancelLoan"],
    mutationFn: async (e) => {
      e.preventDefault()
      return await acceptRepayment({ reason, status: 'REJECTED', id: props?.id, loanId: props?.loanId })
    },
    onSuccess: (res) => {
      if (res?.name === 'AxiosError' || res?.status === 400 || res?.response?.status === 400) {
        toast.error(res?.response?.data?.message || 'Error while approving request');
      } else {
        toast.success(res?.data?.message || res?.message || 'Request cancelled successfully');
      }
      navigate(`/finance?payment-requests`)
    },
    onError: (error) => {
      console.log({ error })
      toast.error('Error while approving request');
      console.log(error);
    }
  })


  const closeModal = () => {
    props.setshow(false);
    setReason("");
    setError("");
  };

  const handleDecline = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setError("Please provide a reason for cancellation");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const response = await axios.post(
        `/v1/admin/new-finance/cancel/${id}`,
        {
          reason: reason.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      if (response?.data?.error) {
        const errorData = await response?.data;
        throw new Error(errorData?.message || `HTTP error! status: ${response?.status}`);
      }

      const data = await response?.data;

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Request canceled successfully!",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      if (props.onDecline) {
        props.onDecline(reason, data);
      }

      closeModal();
      setTimeout(() => navigate(-1), 300);
    } catch (error) {
      console.error("Error declining request:", error);
      setError(error.message || "Failed to decline request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    content: {
      margin: "5% auto",
      overflow: "hidden",
      maxWidth: "400px",
      height: "320px",
      width: "85%",
      padding: "20px",
      borderRadius: "8px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  return (
    <Modal
      isOpen={props.show}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Cancel Loan Modal"
    >
      <div className="modal-header">
        <span className="material-icons close-icon" onClick={closeModal}>
          close
        </span>
      </div>

      <div className="flex flex-col items-center justify-center modal-content">
        <h3 className="w-[295px] text-[20px] text-[#101828] font-bold text-center mb-4">
          Are you sure you want to {props?.from ? "reject" : "cancel"} this {props?.from ? "payment" : "loan"}
        </h3>

        <form onSubmit={(e) => props?.from ? cancelLoan(e) : handleDecline(e)} className="w-full decline-form">
          <div className="w-full form-group bg-[#ECEFF3] px-2 pt-2 rounded-[8px]">
            <div className="text-[#667085] text-xs px-2">Leave a reason</div>
            <textarea
              id="reason"
              placeholder="Enter text here"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={4}
              className="w-full h-[50px] bg-[#ECEFF3] outline-none focus:ring-2 focus:ring-gray-100 px-2"
              required
            />
          </div>
          {/* {error && <div className="mt-2 text-sm text-red-500">{error}</div>} */}
          <Button
            className="w-full mt-4 p-4 rounded-[10px] bg-[#EBE4FF] font-bold text-[#6F00FF] hover:bg-[#EBE4FF] hover:text-[#6F00FF]"
            disabled={loading}
          >
            {loading ? <Loading /> : props?.from ? "Reject repayment" : "Cancel loan"}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default CancelLoanModal;
